import { US_STATES } from '@hts/shared';
import { TextInput, SelectInput } from '../components/FormField';
import type { FormData } from '../types';

interface Props {
  data: FormData;
  onChange: (updates: Partial<FormData>) => void;
  errors?: Record<string, string>;
}

const stateOptions = US_STATES.map((s) => ({ value: s, label: s }));

export function CompanyInfoStep({ data, onChange, errors = {} }: Props) {
  return (
    <div>
      <div className="step-header">
        <h2>Company Information</h2>
        <p>Enter your company's legal name and main office address. This is the name and address that will appear on all contracts and payments.</p>
      </div>

      <TextInput
        label="Company Name"
        required
        value={data.companyName}
        error={errors.companyName}
        placeholder="Example: Smith Electric LLC"
        hint="Your company's full legal name as registered with the state"
        onChange={(e) => onChange({ companyName: e.target.value })}
      />

      <TextInput
        label="Street Address"
        required
        value={data.addressLine1}
        error={errors.addressLine1}
        placeholder="Example: 123 Main Street"
        onChange={(e) => onChange({ addressLine1: e.target.value })}
      />

      <TextInput
        label="Address Line 2"
        value={data.addressLine2}
        placeholder="Suite, unit, building, floor, etc. (if needed)"
        onChange={(e) => onChange({ addressLine2: e.target.value })}
      />

      <div className="form-row-3">
        <TextInput
          label="City"
          required
          value={data.city}
          error={errors.city}
          placeholder="Example: Dallas"
          onChange={(e) => onChange({ city: e.target.value })}
        />
        <SelectInput
          label="State"
          required
          value={data.state}
          error={errors.state}
          options={stateOptions}
          placeholder="Choose state..."
          onChange={(e) => onChange({ state: e.target.value })}
        />
        <TextInput
          label="ZIP Code"
          required
          value={data.zip}
          error={errors.zip}
          placeholder="Example: 75201"
          onChange={(e) => onChange({ zip: e.target.value })}
        />
      </div>

      <div className="form-row">
        <TextInput
          label="Phone Number"
          required
          type="tel"
          value={data.phone}
          error={errors.phone}
          placeholder="Example: (555) 123-4567"
          hint="Your company's main phone number"
          onChange={(e) => onChange({ phone: e.target.value })}
        />
        <TextInput
          label="Website"
          type="url"
          placeholder="Example: https://www.yourcompany.com"
          hint="Optional"
          value={data.website}
          onChange={(e) => onChange({ website: e.target.value })}
        />
      </div>

      <TextInput
        label="EIN / Tax ID"
        required
        placeholder="Example: 12-3456789"
        value={data.einTaxId}
        error={errors.einTaxId}
        hint="Your 9-digit Employer Identification Number from the IRS. You can find this on your W-9 form or IRS determination letter."
        onChange={(e) => onChange({ einTaxId: e.target.value })}
      />
    </div>
  );
}
